import { render } from "./StoreEmailConfig.vue?vue&type=template&id=ae12dd3e&scoped=true"
import script from "./StoreEmailConfig.vue?vue&type=script&lang=js"
export * from "./StoreEmailConfig.vue?vue&type=script&lang=js"

import "./StoreEmailConfig.vue?vue&type=style&index=0&id=ae12dd3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae12dd3e"]])

export default __exports__